import { useAuth0 } from '@auth0/auth0-react';
import { Box, Container, useTheme } from '@mui/material';
import { ThemeTypography } from '../../components/common/ThemeTypography';
import ThemeButton from '../../components/common/ThemeButton';

type Props = {
  error: Error;
};

export const ErrorPageAuth = ({ error }: Props) => {
  const theme = useTheme();
  const { logout } = useAuth0();
  const handleLogin = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Container
      sx={{ display: 'flex', flexDirection: 'column', height: '100svh', justifyContent: 'center' }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Page Title */}
        <ThemeTypography type="heading1" color={theme.palette.customColors.emerald}>
          Hoppsan nu var det något som gick fel
        </ThemeTypography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '20px',
        }}
      >
        <ThemeTypography>{error?.message}</ThemeTypography>

        <ThemeTypography>Prova logga in igen</ThemeTypography>

        <ThemeButton onClick={handleLogin}>Logga in</ThemeButton>
      </Box>
    </Container>
  );
};
